<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { computed } from "vue";

const { tm } = useI18n();

const instruction = computed(
  () => tm("calculators.iczin.instruction") as unknown
);
</script>

<template>
  <div class="text-brown">
    <h2 class="text-2xl font-semibold mb-4">
      {{ instruction.first_title }}
    </h2>

    <p class="text-base leading-[20px]">
      {{ instruction.first_paragraph }}
    </p>
    <p class="text-base leading-[20px]">
      {{ instruction.second_paragraph }}
    </p>

    <p class="text-base leading-[20px] font-bold">
      {{ instruction.second_title }}
    </p>
    <ul class="list-disc space-y-1 pl-6">
      <li
        v-for="(item, i) in instruction.list"
        :key="i"
        class="text-base leading-[20px]"
      >
        {{ item }}
      </li>
    </ul>

    <p class="text-base leading-[20px]">
      {{ instruction.third_paragraph }}
    </p>
  </div>
</template>
